import React from 'react'

import Component from './component'

export default () => (
    <Component />
)